import {
  ReportContainer,
  ReportInfo,
  ReportName,
} from "./LabReportListItem.style";
import { ILabReportData } from "@home-health-notify/domain/build/chat/labs/ILabOrderData";
import DocumentThumbBox from "../info/common/DocumentThumbBox";
import { ATTACHMENT_TYPE } from "@home-health-notify/domain";
import React, { useState } from "react";
import DocumentPreview from "../../../message/documentViewer/DocumentPreview";

export interface ReportListItemProps {
  report: ILabReportData;
}

const LabReportListItem = ({ report }: ReportListItemProps) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpen(true);
  };

  return (
    <ReportContainer onClick={handleClick}>
      <DocumentThumbBox
        fileName={report.fileName}
        url={report.fileUrl}
        iconWidth={40}
      />
      <ReportInfo>
        <ReportName>{report.fileName}</ReportName>
      </ReportInfo>
      {report.fileType === "pdf" && open && (
        <DocumentPreview
          url={report.fileUrl}
          onSetDocUrl={() => {}}
          docType={ATTACHMENT_TYPE.PDF}
          onAutoOpen={() => {
            setOpen(false);
          }}
        />
      )}
    </ReportContainer>
  );
};

export default LabReportListItem;
